import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import Swal from 'sweetalert2';

import { SpinnerService } from '../../shared/components/spinner/spinner.service';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {
  constructor(private spinnerService: SpinnerService) {}

  public delay(ms) {
    const startPoint = new Date().getTime();
    while (new Date().getTime() - startPoint <= ms) {
      /* wait */
    }
  }

  // Intercept the request to set header.
  public intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.spinnerService.show();
    const token = localStorage.getItem('JWT_TOKEN');
    const params = {
      'Content-Language': 'en'
    };

    if (
      (req.url.indexOf('login') === -1 || req.url.indexOf('login_restrictions') !== -1) &&
      token &&
      req.url.indexOf('B2B/processor') === -1 &&
      req.url.indexOf('geocode') === -1 &&
      req.url.indexOf('decodevinvaluesextended') === -1
    ) {
      req = req.clone({
        setHeaders: { ...params, Authorization: 'Token ' + token }
      });
    } else {
      req = req.clone({
        setHeaders: params
      });
    }
    if (localStorage.getItem('DB-DOWN') === 'YES' && req.url.includes('api')) {
      Swal.fire(
        'Please wait',
        'The system is restarting, your request will be processed in 30 seconds!',
        'info'
      );
      // Delay for 45s to wait until the db is up again
      setTimeout(() => {
        this.delay(45000);
      }, 10);
      return next.handle(req).pipe(
        tap(
          (event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
              this.spinnerService.hide();
            }
          },
          error => {
            this.spinnerService.hide();
          }
        )
      );
    } else {
      return next.handle(req).pipe(
        tap(
          (event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
              this.spinnerService.hide();
            }
          },
          error => {
            this.spinnerService.hide();
          }
        )
      );
    }
  }
}
